export default __webpack_public_path__ + "static/media/gift_hive.18b57d27.svg";